/* Belly&Moi — Accordéons exclusifs : tout <details data-bm-accordion-group="…"> (accordéons de la colonne produit,
   snippets/bm-accordion.liquid ; FAQ, sections/bm-faq.liquid).
   1. Accordéon exclusif : les <details> d'un même groupe portent le même attribut name, donc le navigateur ferme
      lui-même l'autre quand on en ouvre un. Secours pour les navigateurs qui ne gèrent pas name
      sur <details> (anciens Safari) : on ferme à la main les autres du même groupe.
   2. Pas de saut de page : si un accordéon placé au-dessus se ferme pendant qu'on en ouvre un autre,
      le titre cliqué remonterait ; on le remet à la même hauteur à l'écran.
   Chargé une seule fois même s'il est inclus plusieurs fois. */
(function () {
  if (window.bmAccordionReady) return;
  window.bmAccordionReady = true;

  var nativeExclusive = 'name' in document.createElement('details');
  var pending = null; // { summary, top } : titre cliqué et sa position avant l'ouverture

  document.addEventListener(
    'click',
    function (event) {
      var summary = event.target.closest && event.target.closest('details[data-bm-accordion-group] > summary');
      if (!summary) return;
      pending = { summary: summary, top: summary.getBoundingClientRect().top };
    },
    true
  );

  // L'événement toggle ne remonte pas : écoute en phase de capture.
  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!details.hasAttribute || !details.hasAttribute('data-bm-accordion-group')) return;
      if (!details.open) return;

      var group = details.getAttribute('data-bm-accordion-group');
      if (!nativeExclusive && group) {
        document.querySelectorAll('details[data-bm-accordion-group]').forEach(function (other) {
          if (other !== details && other.open && other.getAttribute('data-bm-accordion-group') === group) {
            other.open = false;
          }
        });
      }

      if (pending && details.contains(pending.summary)) {
        var shift = pending.summary.getBoundingClientRect().top - pending.top;
        if (Math.abs(shift) > 1) window.scrollTo(0, window.pageYOffset + shift);
      }
      pending = null;
    },
    true
  );
})();
